export const financialCalendarRoutePaths = {
  financialCalendar: {
    path: 'financial-calendar',
    url: '/financial-calendar',
  },
  // TRAD-3709 P1 — 일자별 페이지(YYYY-MM-DD 검증은 페이지가 한다 — 틀린 값은 NotFound).
  financialCalendarDay: {
    path: 'financial-calendar/:date',
  },
} as const;
